<template>
  <div class="sin-resultados-container">
    <div class="icon-wrapper mb-20">
      <CustomIcon :icon="icon" size="30px" size-mobile="30px" class="red-icon" />
    </div>
    <div class="text-primary p semibold mb-10">
      {{ titulo || $t('general.sinResultados') }}
    </div>
    <div class="sin-resultados-descripcion text-primary small mb-10">
      {{ descripcion || $t('general.filtraDeNuevo') }}
    </div>
  </div>
</template>

<script setup>
  import CustomIcon from '@/components/CustomIcon.vue';
  import warningIcon from '@/assets/icons/warning.svg';

  defineProps({
    icon: {
      type: String,
      default: warningIcon,
    },
    titulo: {
      type: String,
      default: '',
    },
    descripcion: {
      type: String,
      default: '',
    },
  });
</script>

<style scoped lang="scss">
  .sin-resultados-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding-top: 60px;
    padding-left: 40px;
    padding-right: 40px;
    padding-bottom: 250px;

    @media (max-width: 768px) {
      padding: 20px;
    }
  }

  .icon-wrapper {
    width: 50px;
    height: 50px;
    border-radius: 12px;
    background-color: var(--rojo-50);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .sin-resultados-descripcion {
    white-space: pre-line;
  }

  .red-icon {
    color: var(--rojo-600);
  }
</style>
